import { render, staticRenderFns } from "./GroupField.vue?vue&type=template&id=56b24f3d&lang=pug&"
import script from "./GroupField.vue?vue&type=script&lang=js&"
export * from "./GroupField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b24f3d')) {
      api.createRecord('56b24f3d', component.options)
    } else {
      api.reload('56b24f3d', component.options)
    }
    module.hot.accept("./GroupField.vue?vue&type=template&id=56b24f3d&lang=pug&", function () {
      api.rerender('56b24f3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/blocs/GroupField.vue"
export default component.exports